import { useId } from 'react';

interface HeartLogoProps {
  size?: number;
  glow?: boolean;
  mono?: boolean;
  className?: string;
}

export function HeartLogo({
  size = 64,
  glow = true,
  mono = false,
  className,
}: HeartLogoProps): JSX.Element {
  const reactId = useId();
  const gid = `hl-${reactId.replace(/:/g, '')}`;
  const pink = mono ? 'currentColor' : '#EC4899';
  const pinkLight = mono ? 'currentColor' : '#F9A8D4';
  const pinkDark = mono ? 'currentColor' : '#BE1865';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={`${gid}g`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor={pinkLight} />
          <stop offset=".55" stopColor={pink} />
          <stop offset="1" stopColor={pinkDark} />
        </linearGradient>
        {glow && (
          <radialGradient id={`${gid}h`} cx=".35" cy=".25" r=".5">
            <stop offset="0" stopColor="#fff" stopOpacity=".55" />
            <stop offset="1" stopColor="#fff" stopOpacity="0" />
          </radialGradient>
        )}
      </defs>
      {/* Heart */}
      <path
        d="M32 56s-22-12-22-29c0-7 5-12 12-12 4 0 7.5 2 10 6 2.5-4 6-6 10-6 7 0 12 5 12 12 0 17-22 29-22 29z"
        fill={mono ? pink : `url(#${gid}g)`}
      />
      {/* Padlock body */}
      <rect x="22" y="27" width="20" height="16" rx="3" fill="#fff" opacity={mono ? 0 : 0.16} />
      <rect x="22" y="27" width="20" height="16" rx="3" fill="none" stroke="#fff" strokeWidth="2.5" />
      {/* Shackle */}
      <path
        d="M26 27v-4a6 6 0 0 1 12 0v4"
        fill="none"
        stroke="#fff"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      {/* Keyhole */}
      <circle cx="32" cy="34" r="1.75" fill="#fff" />
      <path d="M32 34v3.5" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}
